// UI strings for the week walked in order (course/weekNext.ts stepGates; Axel 2026-10-06): a step
// opens when the one before it is done. A locked step names what opens it, keyed by the step to do
// first (StepGate.after); its page, opened by URL, links to that step.
// Finnish (default) and English side by side; en has the same shape.
// Style: docs/FINNISH-STYLE.md (sinä-muoto, no internal jargon, only actionable text).
import { defineArea } from '../area';
import type { WeekStep } from '../../course/week';

export const weekOrderFi = {
  /** Why a step is not open yet, by the step to do first. */
  opensAfter: {
    lesson: 'Avautuu, kun Tunti on tehty',
    practice: 'Avautuu, kun päivän kortit on tehty',
    listen: 'Avautuu, kun Kuuntele-askel on tehty',
    speak: 'Avautuu, kun Puhu-askel on tehty',
    letter: 'Avautuu, kun viikon kirje on kirjoitettu',
    together: 'Avautuu, kun Yhdessä-askel on tehty',
  } satisfies Record<WeekStep, string>,
  /** A locked step's page: the way to the step to do first. */
  doFirst: (step: string) => `Tee ensin: ${step}`,
  /** For screen readers, after a locked step's name in the ribbon. */
  locked: 'ei vielä auki',
};

const weekOrderEn: typeof weekOrderFi = {
  opensAfter: {
    lesson: 'Opens once Lesson is done',
    practice: 'Opens once today’s cards are done',
    listen: 'Opens once Listen is done',
    speak: 'Opens once Speak is done',
    letter: 'Opens once the week’s letter is written',
    together: 'Opens once Together is done',
  },
  doFirst: (step) => `First: ${step}`,
  locked: 'not open yet',
};

// Messages.weekOrder (i18n/area.ts: collected by area-registry.ts)
export const area = defineArea('weekOrder', weekOrderFi, weekOrderEn);
declare module '../area' {
  interface AreaMessages extends Record<typeof area.key, typeof weekOrderFi> {}
}
